import React, { ReactNode } from "react";
import { faPlus, faMinus, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import useTranslation from "../../../../hooks/useTranslation";
import { ToolbarButton, ToolbarPill } from "../Toolbar";

interface Props {
    onZoomIn: () => void;
    onZoomOut: () => void;
    onRotate: () => void;
    disabled?: boolean;
    children?: ReactNode;
}

// Floating document controls (zoom, rotate + consumer extras) for the classic
// react-pdf viewer, shown as an overlay pill in the top-right corner.
export default function Toolbar({ onZoomIn, onZoomOut, onRotate, disabled, children }: Props) {
    const { t } = useTranslation();

    return (
        <ToolbarPill>
            <ToolbarButton
                icon={faPlus}
                title={t("actions.pdf.zoom_in")}
                onClick={onZoomIn}
                disabled={disabled}
            />
            <ToolbarButton
                icon={faMinus}
                title={t("actions.pdf.zoom_out")}
                onClick={onZoomOut}
                disabled={disabled}
            />
            <ToolbarButton
                icon={faRotateRight}
                title={t("actions.pdf.rotate")}
                onClick={onRotate}
                disabled={disabled}
            />
            {children}
        </ToolbarPill>
    );
}
